module.exports = __webpack_public_path__ + "img/menu.2fb7e2b7.svg";